import React, { useEffect, useState } from "react";
import "./ProfilePage.scss";
import avatarImage from "../../assets/images/avatar.webp";
import backgroundimage from "../../assets/images/profile-bkg.jpeg";
import EditProfileModal from "./EditProfileModal";
import EditCompanyModal from "./EditCompanyModal";
import NotificationPanel from "../Notification/NotificationPanel";
import PageLoader from "../../pages/PageLoader/PageLoader";

const ProfilePage: React.FC = () => {
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);
  const [isContainerModalOpen, setIsContainerModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [profileInfo, setProfileInfo] = useState({
    fullName: "",
    role: "",
    email: "",
    phone: "",
    password: "",
  });
  const [companyInfo, setCompanyInfo] = useState({
    companyName: "",
    gstNo: "",
    address: "",
  });

  useEffect(() => {
    // Simulate loading delay - wait for the loader animation to complete
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    const userEmail = localStorage.getItem("userEmail");

    if (userEmail === "operation@cnbtek.com") {
      const profileInfo = {
        fullName: "Amir Pathan",
        role: "Federation Admin",
        email: "operation@cnbtek.com",
        phone: "9561281481",
        password: "password",
      };
      setProfileInfo(profileInfo);

      const companyInfo = {
        companyName: "CNB Integrated Logistics Solutions Pvt. Ltd.",
        gstNo: "27AAQCM9464R1Z5",
        address:
          "EMPEZAR GLOBAL CHIRLE, BELONDAKR, CHIRLE POST URAN, RAIGAD, MAHARASHTRA - 411035",
      };
      setCompanyInfo(companyInfo);
    } else if (userEmail === "nakshfed@cnbtek.com") {
      const profileInfo = {
        fullName: "Naksh Federation",
        role: "Federation Admin",
        email: "nakshfed@cnbtek.com",
        password: "password",
        phone: "xxxxxxxxxx",
      };
      setProfileInfo(profileInfo);

      const companyInfo = {
        companyName: "Naksha Transport",
        gstNo: "xxxxxxxxxxxxxxx",
        address: "MAHARASHTRA",
      };
      setCompanyInfo(companyInfo);
    } else if (userEmail === "it@acmpl.co") {
      const profileInfo = {
        fullName: "Prashant Patil",
        role: "Federation Admin",
        email: "it@acmpl.co",
        password: "password",
        phone: "7208930094",
      };
      setProfileInfo(profileInfo);

      const companyInfo = {
        companyName: "Naksha Transport",
        gstNo: "xxxxxxxxxxxxxxx",
        address: "MAHARASHTRA",
      };
      setCompanyInfo(companyInfo);
    } else if (userEmail === "globiconfed@cnbtek.com") {
      const profileInfo = {
        fullName: "Globicon Terminals",
        role: "Federation Admin",
        email: "globiconfed@cnbtek.com",
        password: "password",
        phone: "xxxxxxxxxx",
      };
      setProfileInfo(profileInfo);

      const companyInfo = {
        companyName: "Globicon Terminals",
        gstNo: "xxxxxxxxxxxxxxx",
        address: "Village-Khoproli, Taluka-Uran, Navi Mumbai - 410 212",
      };
      setCompanyInfo(companyInfo);
    } else {
      // Default profile for other users
      const profileInfo = {
        fullName: "Demo Fed",
        role: "Federation Admin",
        email: userEmail || "demofed@cnbtek.com",
        phone: "xxxxxxxxxx",
        password: "password",
      };
      setProfileInfo(profileInfo);

      const companyInfo = {
        companyName: "CNB Integrated Logistics Solutions Pvt. Ltd.",
        gstNo: "27AAQCM9464R1Z5",
        address:
          "Enzyme Tech Park #1604, Ground Floor, 25th Main, 22nd Cross Rd, Sector 2, HSR Layout, Bengaluru, Karnataka - 560102",
      };
      setCompanyInfo(companyInfo);
    }

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <div className="profile-page p-[20px]">
      {/* <NotificationPanel /> */}
      <div className="profile-card">
        <div className="card-top">
          <img
            src={backgroundimage}
            alt="Background"
            className="background-image"
          />
          <div className="avatar">
            <img src={avatarImage} alt="Profile" className="avatar-image" />
          </div>
        </div>

        <div className="containerbox">
          {/* Personal Information Section */}
          <div className="container personal-info">
            <div className="header-row">
              <h2>Personal Information</h2>
              {/* <button
                className="edit-button"
                onClick={() => setIsProfileModalOpen(true)}
              >
                Edit
              </button> */}
            </div>
            <div className="flex-row">
              <div className="flex-col half-width">
                <div className="label">Full Name:</div>
                <div className="value">{profileInfo.fullName}</div>
              </div>
              <div className="flex-col half-width">
                <div className="label">Role:</div>
                <div className="value">{profileInfo.role}</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="flex-col third-width">
                <div className="label">Email:</div>
                <div className="value">{profileInfo.email}</div>
              </div>
              <div className="flex-col third-width">
                <div className="label">Phone:</div>
                <div className="value">+91 {profileInfo.phone}</div>
              </div>
              <div className="flex-col third-width">
                <div className="label">Password:</div>
                <div className="value">
                  {"*".repeat(profileInfo.password.length)}
                </div>
              </div>
            </div>
          </div>

          {/* Container Information Section */}
          <div className="container container-info">
            <div className="header-row">
              <h2>Company Information</h2>
              {/* <button
                className="edit-button"
                onClick={() => setIsContainerModalOpen(true)}
              >
                Edit
              </button> */}
            </div>
            <div className="flex-row">
              <div className="flex-col half-width">
                <div className="label">Company Name:</div>
                <div className="value">{companyInfo.companyName}</div>
              </div>
              <div className="flex-col half-width">
                <div className="label">GST No.:</div>
                <div className="value">{companyInfo.gstNo}</div>
              </div>
            </div>
            <div className="flex-row">
              <div className="flex-col third-width">
                <div className="label">Address:</div>
                <div className="value">{companyInfo.address}</div>
              </div>
            </div>
          </div>

          {/* Modals for Editing */}
          {/* <EditProfileModal
            isOpen={isProfileModalOpen}
            onClose={() => setIsProfileModalOpen(false)}
            initialData={profileInfo}
          />

          <EditCompanyModal
            isOpen={isContainerModalOpen}
            onClose={() => setIsContainerModalOpen(false)}
            initialData={companyinfo}
          /> */}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
